/**
 * Get config value
 * @param key
 * @returns {*}
 */
export function config(key) {
    if(typeof cfg == 'undefined') {
        return null;
    }

    return JSON.parse(cfg)[key];
}